import React from 'react';

import { State, Dispatch } from '../types/context';

export const StateContext = React.createContext<State>({});
export const DispatchContext = React.createContext<Dispatch | undefined>(undefined);
